let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5jtZi")).then(() => parcelRequire('crJQR'));